<template>
  <div class="dialog" :class="{ 'active' : showDialog }">
    <div
      class="dialog--content dialog--extended-width dialog--extended-extra-large-width u-extra-medium-padding--bottom"
    >
      <h4 class="u-extra-small-margin--bottom">{{ $t('mixingplant.search.title') }}</h4>

      <div class="grid-x grid-margin-x">
        <div class="cell small-auto medium-5">
          <div class="grid-x grid-margin-x">
            <div class="cell small-auto medium-4">
              <div class="form-group">
                <label for="mp_zipcode">PLZ</label>
                <input
                  type="number"
                  name="mp_zipcode"
                  id="mp_zipcode"
                  class="form-control form-control--small"
                  v-model="searchZipcode"
                />
              </div>
            </div>
            <div class="cell small-auto medium-4">
              <div class="form-group">
                <label for="mp_zipcode">Umkreis</label>
                <input
                  type="number"
                  name="mp_radius"
                  id="mp_radius"
                  class="form-control form-control--small"
                  v-model="searchRadius"
                />
              </div>
            </div>
            <div class="cell small-auto medium-4">
              <div class="form-group">
                <label class="invisible">&nbsp;</label>
                <button class="button" @click.prevent="searchMixingplants()">Suche</button>
              </div>
            </div>

            <div class="cell medium-12">
              <div class="callout alert small" v-if="hasError === true">{{ errorMessage }}</div>
              <v-page-loading v-show="isLoading" />
              <ul class="mixingplants-list" v-if="!isLoading">
                <li
                  class="u-extra-small-margin--bottom form-group form-group--check"
                  v-for="(item, index) in mixingplants"
                  :key="index"
                >
                  <label>
                    <input
                      type="checkbox"
                      v-model="selectedMixingplants"
                      name="mixingplants[]"
                      :value="item.id"
                      @change="handleMixingplantCheck(item.id)"
                    />
                    <i></i>
                    <div class="c-ranking" :class="rankingClass(item.ranking)"></div> {{ item.name }}
                    <strong>
                      <em>({{ item.distance | convertDistance }} KM)</em>
                    </strong>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="cell small-auto medium-7">
          <div class="mixingplants-map">
            <div class="leaflet-map leaflet-map--map">
              <div :id="'mp-leaflet-map-' + _uid" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-x grid-margin-x">
        <div class="cell auto">
          <button
            @click.prevent="addMixingplantsToRoute"
            class="button"
          >{{ $t('mixingplant.search.add') }}</button>
        </div>
      </div>

      <button class="close-button" @click.prevent="onCloseDialog">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet-control-geocoder";
import PageLoading from "./../partials/PageLoading";

export default {
  name: "MixingPlantSearchModal",

  components: {
    vPageLoading: PageLoading
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    zipcode: {
      type: String,
      default: ""
    },
    rowUid: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "showDialog",
    event: "showchange"
  },
  data() {
    return {
      mixingplants: [],
      selectedMixingplants: [],
      isLoading: false,
      searchZipcode: "",
      searchRadius: 30,
      searchLatitude: "",
      searchLongitude: "",
      defaultCountry: "Deutschland",
      map: null,
      mapCenter: [51.1657, 10.4515],
      mapZoom: 10,
      mapGroup: null,
      mapMarkers: [],
      hasError: false,
      errorMessage: null
    };
  },
  watch: {
    zipcode() {
      this.searchZipcode = this.$props.zipcode;
    }
  },
  filters: {
    convertDistance: function(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  computed: {
    showDialog: {
      get: function() {
        if (this.isVisible) {
          this.onOpenDialog();
        }
        return this.isVisible;
      },
      set: function(value) {
        this.$emit("showchange", value);
      }
    }
  },
  methods: {

    rankingClass: function (ranking) {
        if (ranking == '') {
            ranking = 'none';
        }
        return 'c-ranking--' + ranking;
    },

    onOpenDialog: function() {
      setTimeout(
        function() {
          this.initializeMap();
          this.searchMixingplants();
        }.bind(this),
        200
      );
      this.showDialog = true;
    },

    onCloseDialog: function() {
      this.resetMap();
      this.showDialog = false;
    },

    initializeMap: function() {
      if (this.map !== null && this.map !== undefined) {
        return;
      }

      this.map = L.map("mp-leaflet-map-" + this._uid, {
        zoom: this.mapZoom,
        keyboard: false
      });

      this.map.setView(this.mapCenter);

      L.tileLayer(
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png",
        {
          maxZoom: 10,
          id: "mapbox.light",
          attribution: ""
        }
      ).addTo(this.map);

      this.mapGroup = new L.featureGroup().addTo(this.map);
    },

    addMapMarker: function(position, name, markerIcon) {
      let marker = new L.Marker(position, {
        icon: markerIcon ? markerIcon : new L.Icon.Default()
      });
      marker.addTo(this.mapGroup);
      marker.bindPopup(name);
      this.mapMarkers.push(marker);
      this.setMap();
    },

    setMap: function() {
      let bounds = this.mapGroup.getBounds();

      if (bounds.isValid()) {
        this.map.fitBounds(bounds);
      } else {
        this.map.setView(this.mapCenter);
      }
    },

    resetMap: function() {
      this.clearMarkers();
      this.map.setView(this.mapCenter);
      this.map.setZoom(this.mapZoom);
      this.mapMarkers = [];
      this.mixingplants = [];
      this.selectedMixingplants = [];
      this.hasError = false;
      this.errorMessage = null;
    },

    clearMarkers: function() {
      this.mapMarkers.forEach(marker => {
        this.mapGroup.removeLayer(marker);
      });
    },

    getSearchLatLon: function() {
      this.resetMap();
      let promise = this.$geocoder.leafletGeo(
        this.searchZipcode + " " + this.defaultCountry
      );
      return promise
        .then(response => {
          this.searchLatitude = response.center.lat;
          this.searchLongitude = response.center.lng;
          this.addStartSearchMarker();
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },

    addStartSearchMarker: function() {
      this.addMapMarker(
        new L.LatLng(this.searchLatitude, this.searchLongitude),
        this.searchZipcode,
        this.startMarkerIcon(this.searchZipcode)
      );
    },

    searchMixingplants: function() {
      this.getSearchLatLon()
        .then(() => {
          if (!this.searchLatitude || !this.searchLongitude) {
            this.handleError(
              this.$t("mixingplant.search.error.no_address", {
                zipcode: this.searchZipcode
              })
            );
          }

          this.isLoading = true;

          this.$api
            .clearParams()
            .addParam("latitude", this.searchLatitude)
            .addParam("longitude", this.searchLongitude)
            .addParam("distanceInKm", this.searchRadius)
            .addParam("sortby", "distance")
            .get("mixingplants")
            .then(response => {
              this.mixingplants = [].concat(response.data.data).sort((a,b) => a.distance - b.distance)
            })
            .catch(() => {
              this.handleError(this.$t("no_results_found"));
            })
            .finally(() => {
              this.isLoading = false;
            });
        })
        .catch(() => {
          this.handleError(
            this.$t("mixingplant.search.error.no_address", {
              zipcode: this.searchZipcode
            })
          );
        });
    },

    handleError: function(message) {
      this.hasError = true;
      this.errorMessage = message;
    },

    handleMixingplantCheck: function(mpId) {
      this.clearMarkers();
      this.addStartSearchMarker();
      this.selectedMixingplants.forEach(selectedId => {
        let key = this.mixingplants.findIndex(row => row.id == selectedId);
        if (key === undefined || this.mixingplants[key] === undefined) {
          return;
        }
        let mixingplant = this.mixingplants[key];
        let position = new L.LatLng(mixingplant.lat, mixingplant.lon);
        this.addMapMarker(position, mixingplant.name);
      });
    },

    startMarkerIcon: function() {
      return L.divIcon({
        className: "leaflet-marker-number leaflet-marker-number-red",
        iconSize: [30, 49],
        iconAnchor: [10, 44],
        popupAnchor: [3, -40]
      });
    },

    addMixingplantsToRoute: function() {
      let mixingplantsToRoute = [];
      this.selectedMixingplants.forEach(id => {
        let key = this.mixingplants.findIndex(row => row.id == id);
        if (key !== undefined && this.mixingplants[key] !== undefined) {
          mixingplantsToRoute.push(this.mixingplants[key]);
        }
      });
      this.$emit("addMixingplantsToRoute", mixingplantsToRoute, this.rowUid);
      this.onCloseDialog();
    }
  }
};
</script>
